import React from "react";
import { Dumbbell, BookOpen, ScanLine, Users, Wallet, BarChart3 } from "lucide-react";
import "./coach-landing.css";

export default function CoachLandingSolution() {
  const features = [
    {
      Icon: Dumbbell,
      title: "Sube tus entrenamientos",
      description: "Tus vídeos, rutinas y programas aparecen dentro de Feed con tu nombre y tu foto."
    },
    {
      Icon: BookOpen,
      title: "Publica guías y ebooks",
      description: "PDFs, recetarios, guías nutricionales... Todo accesible para tu comunidad desde la app. Tu escaparate."
    },
    {
      Icon: ScanLine,
      title: "Escaneo de comidas con IA",
      description: "Tus clientes escanean sus comidas, obtienen calorías y macros al instante. Sin que tú hagas nada."
    },
    {
      Icon: Users,
      title: "Gestiona tus clientes",
      description: "Panel profesional para diseñar los planes de entrenamiento y alimentación de tus clientes, chat en tiempo real y seguimiento de su progreso."
    },
    {
      Icon: Wallet,
      title: "Cobros y facturación",
      description: "Lleva el control de lo que te ha pagado cada cliente y lo que tienes pendiente, con sus comprobantes. Sin hojas de cálculo aparte."
    },
    {
      Icon: BarChart3,
      title: "Estadísticas en tiempo real",
      description: "Clientes activos, adherencia a los planes, likes en tu contenido... Todo en tu panel. Datos para tomar mejores decisiones."
    }
  ];

  return (
    <section className="solution-section">
      <div className="container">
        <div className="solution-header">
          <div className="section-tag">La solución</div>
          <h2 className="section-title">Todo lo que necesitas. En un solo lugar. Gratis.</h2>
          <p className="section-subtitle">Wayo te da las herramientas profesionales que otros te cobran totalmente GRATIS.</p>
        </div>
        <div className="features-grid">
          {features.map(({ Icon, title, description }) => (
            <div key={title} className="feature-card">
              <div className="feature-icon">
                <Icon size={26} strokeWidth={2} aria-hidden="true" />
              </div>
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
